module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av266-c97dc6f089cb040ff3c9632481f5fc1d.jpg";